(function() {
  window.CartSync = {
    formatMoney: function(cents) {
      if (window.W4U) return W4U.formatPrice(cents);
      return '€' + (cents / 100).toFixed(2);
    },

    update: function(key, quantity, callback) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        CartSync.syncUI(cart);
        if (callback) callback(cart);
        if (cart.item_count === 0) location.reload();
      });
    },

    syncUI: function(cart) {
      var fmt = CartSync.formatMoney;

      document.querySelectorAll('[data-cart-count]').forEach(function(el) {
        el.textContent = cart.item_count;
      });

      document.querySelectorAll('[data-cart-subtotal]').forEach(function(el) {
        el.textContent = fmt(cart.total_price);
        el.setAttribute('data-price-cents', cart.total_price);
      });

      document.querySelectorAll('[data-drawer-subtotal]').forEach(function(el) {
        el.textContent = fmt(cart.total_price);
        el.setAttribute('data-price-cents', cart.total_price);
      });

      cart.items.forEach(function(item) {
        var key = item.key;

        document.querySelectorAll('[data-item-key="' + key + '"]').forEach(function(el) {
          var qtyInput = el.querySelector('[data-qty-input]');
          if (qtyInput) qtyInput.value = item.quantity;

          var qtySpan = el.querySelector('[data-drawer-qty]');
          if (qtySpan) qtySpan.textContent = item.quantity;

          var lineTotal = el.querySelector('[data-line-total]');
          if (lineTotal) {
            lineTotal.textContent = fmt(item.final_line_price);
            lineTotal.setAttribute('data-price-cents', item.final_line_price);
          }

          var drawerPrice = el.querySelector('[data-drawer-line-price]');
          if (drawerPrice) {
            drawerPrice.textContent = fmt(item.final_line_price);
            drawerPrice.setAttribute('data-price-cents', item.final_line_price);
          }

          var minusBtn = el.querySelector('[data-qty-minus], [data-drawer-minus]');
          if (minusBtn) minusBtn.disabled = item.quantity <= 1;
        });

        document.querySelectorAll('[data-drawer-item][data-item-key="' + key + '"]').forEach(function(el) {
          var qtySpan = el.querySelector('[data-drawer-qty]');
          if (qtySpan) qtySpan.textContent = item.quantity;
          var drawerPrice = el.querySelector('[data-drawer-line-price]');
          if (drawerPrice) {
            drawerPrice.textContent = fmt(item.final_line_price);
            drawerPrice.setAttribute('data-price-cents', item.final_line_price);
          }
          var minusBtn = el.querySelector('[data-drawer-minus]');
          if (minusBtn) minusBtn.disabled = item.quantity <= 1;
        });
      });

      var cartKeys = cart.items.map(function(i) { return i.key; });
      document.querySelectorAll('[data-item-key]').forEach(function(el) {
        var k = el.getAttribute('data-item-key');
        if (cartKeys.indexOf(k) === -1) {
          el.style.display = 'none';
        }
      });
    }
  };
})();
